// @ts-nocheck
/* eslint-disable */
import { appAlertLedIcon } from './alert-led';
import { appAssignOperatorIcon } from './assign-operator';
import { appAttachmentIcon } from './attachment';
import { appBarcodeIcon } from './barcode';
import { appBoxIsoIcon } from './box-iso';
import { appCalculatorIcon } from './calculator';
import { appCatalogueNumberIcon } from './catalogue-number';
import { appCityIcon } from './city';
import { appCommissionIcon } from './commission';
import { appCommodityIcon } from './commodity';
import { appDocMagnifyingGlassInIcon } from './doc-magnifying-glass-in';
import { appDownloadIcon } from './download';
import { appDragHandGestureIcon } from './drag-hand-gesture';
import { appEditPencilIcon } from './edit-pencil';
import { appFlagIcon } from './flag';
import { appFloppyDiskIcon } from './floppy-disk';
import { appInProgressIcon } from './in-progress';
import { appLotIcon } from './lot';
import { appMergeIcon } from './merge';
import { appNavArrowDownIcon } from './nav-arrow-down';
import { appNavArrowRightIcon } from './nav-arrow-right';
import { appPackagesIcon } from './packages';
import { appPageStarIcon } from './page-star';
import { appPageIcon } from './page';
import { appPalletIcon } from './pallet';
import { appParkingIcon } from './parking';
import { appPauseIcon } from './pause';
import { appPlanIcon } from './plan';
import { appPlusCircleIcon } from './plus-circle';
import { appPriceTagIcon } from './price-tag';
import { appPrintingPageIcon } from './printing-page';
import { appProcessingPhaseIcon } from './processing-phase';
import { appQuantityIcon } from './quantity';
import { appRulerIcon } from './ruler';
import { appScanBarcodeIcon } from './scan-barcode';
import { appSerialNumberIcon } from './serial-number';
import { appSigmaIcon } from './sigma';
import { appSimpleCartIcon } from './simple-cart';
import { appStorageLocationIcon } from './storage-location';
import { appThreeDotsIcon } from './three-dots';
import { appTimeExpiredIcon } from './time-expired';
import { appTimeLeftIcon } from './time-left';
import { appTransitionDownIcon } from './transition-down';
import { appUnassignOperatorIcon } from './unassign-operator';
import { appUploadIcon } from './upload';
import { appXmarkIcon } from './xmark';
export const coreIcons = [appAlertLedIcon, appAssignOperatorIcon, appAttachmentIcon, appBarcodeIcon, appBoxIsoIcon, appCalculatorIcon, appCatalogueNumberIcon, appCityIcon, appCommissionIcon, appCommodityIcon, appDocMagnifyingGlassInIcon, appDownloadIcon, appDragHandGestureIcon, appEditPencilIcon, appFlagIcon, appFloppyDiskIcon, appInProgressIcon, appLotIcon, appMergeIcon, appNavArrowDownIcon, appNavArrowRightIcon, appPackagesIcon, appPageStarIcon, appPageIcon, appPalletIcon, appParkingIcon, appPauseIcon, appPlanIcon, appPlusCircleIcon, appPriceTagIcon, appPrintingPageIcon, appProcessingPhaseIcon, appQuantityIcon, appRulerIcon, appScanBarcodeIcon, appSerialNumberIcon, appSigmaIcon, appSimpleCartIcon, appStorageLocationIcon, appThreeDotsIcon, appTimeExpiredIcon, appTimeLeftIcon, appTransitionDownIcon, appUnassignOperatorIcon, appUploadIcon, appXmarkIcon];
